import script from "./AirdropDate.vue?vue&type=script&setup=true&lang=js"
export * from "./AirdropDate.vue?vue&type=script&setup=true&lang=js"

import "./AirdropDate.vue?vue&type=style&index=0&id=b04617a8&lang=scss&scoped=true"
script.__scopeId = "data-v-b04617a8"

export default script